import { MapItemDetailsProvider } from './map-item-details.provider';
import { MapFilters } from '../map.enum';
import { Coords } from '../../../swagger-api';

export class MapCovidDetailsProvider extends MapItemDetailsProvider {
  readonly filter = MapFilters.COVID;

  fetchLocationForItemById(_id: string): Promise<Coords> {
    return Promise.resolve({ lat: 0, lon: 0 });
  }

  getMarkerIdByEntityId(id: string): string {
    return id;
  }
}
